import React from 'react';
import '../styles/ProfileModal.css';

const CurrencyChangeWarningModal = ({
    currentCurrency,
    newCurrency,
    onConfirm,
    onCancel
}) => {
    const getCurrencySymbol = (currency) => {
        switch (currency) {
            case 'USD': return '$';
            case 'RUB': return '₽';
            case 'BRL': return 'R$';
            case 'USDT': return '₮';
            case 'EUR': return '€';
            default: return '';
        }
    };

    return (
        <div className="profile-modal-overlay" onClick={(e) => {
            if (e.target === e.currentTarget) {
                onCancel();
            }
        }}>
            <div className="profile-modal currency-warning-modal" onClick={(e) => e.stopPropagation()}>
                <button className="profile-modal-close" onClick={onCancel}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="12" fill="#23232e" />
                        <path d="M16 8L8 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                        <path d="M8 8L16 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </button>

                <h3 className="profile-modal-title">⚠️ Предупреждение о смене валюты</h3>

                <div className="currency-warning-content">
                    <div className="currency-change-info">
                        <p style={{ marginBottom: '15px', fontSize: '16px', color: '#fff' }}>
                            Вы собираетесь сменить валюту с <strong style={{ color: '#ffd700' }}>{currentCurrency} ({getCurrencySymbol(currentCurrency)})</strong> на <strong style={{ color: '#ffd700' }}>{newCurrency} ({getCurrencySymbol(newCurrency)})</strong>.
                        </p>

                        <div style={{
                            background: 'rgba(255, 204, 0, 0.1)',
                            border: '1px solid rgba(255, 204, 0, 0.3)',
                            borderRadius: '8px',
                            padding: '15px',
                            margin: '15px 0'
                        }}>
                            <p style={{ margin: '0 0 10px 0', fontWeight: '600', color: '#ffcc00' }}>
                                Внимание! Смена валюты во время активной игровой сессии приведет к:
                            </p>
                            <ul style={{
                                margin: '0',
                                paddingLeft: '20px',
                                color: '#fff',
                                lineHeight: '1.6'
                            }}>
                                <li>Завершению текущей игровой сессии</li>
                                <li>Перезагрузке страницы</li>
                                <li>Запуску новой сессии в выбранной валюте</li>
                                <li>Возможной потере текущего прогресса в игре</li>
                            </ul>
                        </div>

                        <p style={{ margin: '15px 0 0 0', fontSize: '16px', color: '#fff', textAlign: 'center' }}>
                            Вы уверены, что хотите продолжить?
                        </p>
                    </div>

                    <div className="profile-modal-actions" style={{ marginTop: '20px' }}>
                        <button
                            onClick={onConfirm}
                            className="btn sign-up glow-blue"
                            style={{ marginRight: '8px' }}
                        >
                            Да, сменить валюту
                        </button>
                        <button
                            onClick={onCancel}
                            className="profile-modal-cancel-btn"
                        >
                            Отмена
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CurrencyChangeWarningModal;
